import Vue from "vue"

import visible from "./directives/visible/visible"
import navigation from "./directives/navigation/navigation"

Vue.use(visible)
Vue.use(navigation)
